import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { headers } from "../../token";
import JobViews from "./JobView";
import html2pdf from 'html2pdf.js';
import ReactDOM from 'react-dom';
import vAdminformat from '../../adminFormat';
import downloadJobPDF from "./DownloadJob";
import UpdateJobs from "./JobUpdate";
import QRCode from "react-qr-code";
import JobLiveUpdate from "./JobLiveUpdate";
import JobLiveView from "./JobLiveView";
import CustomDateRangePicker from "../CustomDateRangePicker";
import { PieChart, Pie, Cell } from "recharts";

/*import DeletedCustomer from "./DeleteJobs";  */


const server_backend = config.API_URL;
const server_frontend = config.FrondEndURL;

const LiveFeed = ({ email, currentMaterial }) => {
    //console.log(currentMaterial)
    const [JobList, setJobList] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [filtersEnabled, setFiltersEnabled] = useState(currentMaterial ? true : false);
    const [filterBy, setFilterBy] = useState(currentMaterial ? "materials_name" : "fullname")
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState(currentMaterial ? `${currentMaterial}  ` : "");
    const [selectedFilter, setSelectedFilter] = useState("");
    const [viewBJob, setViewBJob] = useState(false);
    const [currentJob, setCurrentJob] = useState(0);
    const intervalRef = useRef(null); //We use a REF to store the interval
    const [refreshRate, setRefreshRate] = useState(60000);

    const [selectedDayRange, setSelectedDayRange] = useState({
        from: null,
        to: null,
    });


    const [loading, setLoading] = useState(false);

    const [statusQuot, setStatusQuot] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    useEffect(() => {
        if (currentMaterial) {
            FilterCustomer();
        } else {

            const getJobs = async () => {
                try {
                    const response = await axios.get(`${server_backend}/Jobs/manual/list`, headers);
                    //console.log({ eo: response.data });
                    if (response.data.RES_CODE === "00") {
                        //This will filter only jobs in production exept complete ones
                        const filterJobs = response.data.RES_RESULT.filter((job) => {
                            return job.status_order !== 7;
                        }
                        );

                        setJobList(filterJobs);
                    }
                } catch (error) {
                    console.log(error)
                }
            }
            getJobs();
        }

    }, []);

    useEffect(() => {
        if (filtersEnabled) {
            FilterCustomer();
        }
    }, [selectedDayRange]);


    const getJobs = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${server_backend}/Jobs/manual/list`, headers);


            if (response.data.RES_CODE === "00") {
                //This will filter only jobs in production exept complete ones
                const filterJobs = response.data.RES_RESULT.filter((job) => {
                    return job.status_order !== 7;
                }
                );

                setJobList(filterJobs);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }


    useEffect(() => {
        //We configure the interval to execute the function every 20 seconds
        if (!currentMaterial && !filtersEnabled) {
            //We set the interval to get the jobs every refreshRate
            intervalRef.current = setInterval(async () => {
                await getJobs();
            }, refreshRate);

            //We clean the interval when the component is disassembled
            return () => {
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                }
            };
        }

    }, [refreshRate, filtersEnabled]); //only run once the component is set up

    useEffect(() => {
        const getStatusJob = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/Job`, headers);
                if (response.data.RES_CODE === "00") {
                    setStatusQuot(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error);
            }
        }
        getStatusJob();
    }, []);

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterCustomer(value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);

    };

    const handleColumnClick = (filterValue) => {
        if (filtersEnabled) {
            setSelectedFilter(filterValue);
            handleFilterByChange({ target: { value: filterValue } });
        }

    };

    const FilterCustomer = async () => {
        try {
            const response = await axios.get(`${server_backend}/Jobs/search?user_transaction=${email}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}&startDate=${selectedDayRange.from}&endDate=${selectedDayRange.to}`, headers);

            const filterJobs = response.data.RES_RESULT.filter((job) => {
                //This will filter only jobs in production exept complete ones
                return job.status_name !== "COMPLETE";
            }
            );
            setJobList(filterJobs);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterCustomer();
        }
    }, [filterBy, filterStatus, filterValue]);

    const showViewJob = () => {
        setViewBJob(true);
    }

    const CloseViewJob = () => {
        setViewBJob(false);
    }

    const CloseModalUpdate = () => {
        setIsUpdating(false);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = JobList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(JobList.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleDateChange = (dates) => {
        setSelectedDayRange({
            from: dates.from,
            to: dates.to,
        });
    };

    const StatusChart = ({ statusId, reprint }) => {

        const COLORS = ["#FF0000", "#FF7F50", "#FFFF00", "#008000"];

        if (statusId === 18 && reprint === false) {
            return <i className="ri-folder-open-line" style={{ fontSize: "45px", color: "#555" }}></i>;
        }
        if (statusId === 18 && reprint === true) {
            return <i className="ri-folder-add-line" style={{ fontSize: "45px", color: "#555" }}></i>;
        }

        let filledSections = 0;
        if (filledSections > 22) filledSections = 4;
        switch (statusId) {
            case 19: filledSections = 1; break;
            case 20: filledSections = 2; break;
            case 21: filledSections = 3; break;
            case 22: filledSections = 4; break;
            default: filledSections = 0;
        }


        const data = Array(4).fill(1).map((_, index) => ({
            value: 1,
            color: index < filledSections ? COLORS[index] : "#E0E0E0"
        }));

        return (
            <PieChart width={50} height={50}>
                <Pie
                    data={data}
                    cx="50%" cy="50%"
                    innerRadius={12}  //Empty center size
                    outerRadius={20}  //Total circle size
                    dataKey="value"
                    startAngle={270}
                    endAngle={-180}
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                </Pie>
            </PieChart>

        );
    };


    return (
        <div className={currentMaterial ? "" : "page-content"} data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "hidden" }}>
            {viewBJob ? (
                <JobLiveView JobID={currentJob} getJobs={getJobs} CloseViewJob={CloseViewJob} />
            ) : (
                isUpdating ? (
                    <JobLiveUpdate CloseViewJob={CloseModalUpdate} JobID={currentJob} getJobs={getJobs} />
                ) : (
                    <div className="">
                        {!currentMaterial && (

                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0">Live Feed</h4>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a href="javascript: void(0);">Jobs</a></li>
                                                <li className="breadcrumb-item active">List</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                        }


                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card" id="tasksList" >
                                    <div className="card-header bJob-0">
                                        <div className="d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1">Job List</h5>

                                            {/*Filters Button */}
                                            <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                                <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                                    <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                                </button>
                                            </div>

                                            <div>
                                                <div className="dropdown">
                                                    <button
                                                        className="btn btn-dark dropdown-toggle"
                                                        type="button"
                                                        id="refreshRateDropdown"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        <i class="mdi mdi-clock-edit-outline" style={{ marginRight: "2px" }}></i><span id="refresh-rate-label">{refreshRate / 1000} Seg</span>

                                                    </button>
                                                    <ul className="dropdown-menu" aria-labelledby="refreshRateDropdown">
                                                        <li>
                                                            <button className="dropdown-item" onClick={() => setRefreshRate(5000)}>
                                                                Refresh every 5 seconds
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <button className="dropdown-item" onClick={() => setRefreshRate(10000)}>
                                                                Refresh every 10 seconds
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <button className="dropdown-item" onClick={() => setRefreshRate(30000)}>
                                                                Refresh every 30 seconds
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <button className="dropdown-item" onClick={() => setRefreshRate(60000)}>
                                                                Refresh every 1 minute
                                                            </button>
                                                        </li>
                                                    </ul>

                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    {filtersEnabled && (
                                        <div className="card-body bJob bJob-dashed bJob-end-0 bJob-start-0">
                                            <div className="row g-3">
                                                <div className="col-4">
                                                    <div className="input-light">
                                                        <select
                                                            className="form-control custom-select-style"
                                                            name="choices-single-default"
                                                            disabled={!filtersEnabled}
                                                            value={filterBy}
                                                            onChange={handleFilterByChange}
                                                        >
                                                            <option value="">Filter by</option>
                                                            <option value="job_number">ID</option>
                                                            <option value="ord_ID">Order Ref.</option>
                                                            <option value="fullname">Customer name</option>
                                                            <option value="materials_name">Material</option>
                                                        </select>

                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="input-light">
                                                        <select
                                                            className="form-control custom-select-style"
                                                            name="choices-single-default"
                                                            id="idFilterStatus"
                                                            disabled={!filtersEnabled}
                                                            onChange={handleFilterStatusChange}
                                                        >
                                                            <option value={0}>Filter status</option>
                                                            {statusQuot.map((status) => (
                                                                <option key={status.est_ID} value={status.est_ID}>{status.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <CustomDateRangePicker onDateChange={handleDateChange} />
                                                </div>
                                                <div className="col-12">
                                                    <div className="search-box">
                                                        <input
                                                            type="text"
                                                            className="form-control search"
                                                            placeholder="Search for tasks or something..."
                                                            disabled={!filtersEnabled}
                                                            onChange={handleFilterValueChange}
                                                        />
                                                        <i className="ri-search-line search-icon"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="card-body">
                                        {loading ? (
                                            <div style={{ height: "80vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <center>
                                                    <div className="spinner-border text-primary justify-content-center" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </center>
                                            </div>
                                        ) : (
                                            <div className="table-responsive" style={{ minHeight: "90vh" }}>
                                                <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                                    <thead className="table-light text-muted align-content-center">
                                                        <tr style={{ textAlign: "center", verticalAlign: "middle", fontSize: "12px" }}>
                                                            <th className="th-hover" onClick={() => handleColumnClick("job_number")}>ID</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("user_created")}>Staff ID</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("fullname")}>Customer <br /> Name</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("comment")}>Description</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("print_type")}>Status</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("materials_name")}>Collective <br />Count</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("materials_name")}>Metal</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("materials_name")}>Quantity</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("materials_name")}>Single QR Data</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("materials_name")}>Collective QR <br /> Group</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("materials_name")}>Expected <br /> Cast Date</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="list form-check-all">
                                                        {currentItems.map((Jobs_L) => (
                                                            <tr key={Jobs_L.job_number} style={{ verticalAlign: "middle", fontSize: "12px" }}>
                                                                <td className="id">
                                                                    <Link className="fw-medium link-primary" style={{ top: "14px" }} onClick={() => {
                                                                        setCurrentJob(!currentMaterial ? Jobs_L.job_ID : Jobs_L.ordj_ID);
                                                                        showViewJob();
                                                                    }}>
                                                                        <div className="d-flex"></div>
                                                                        <h6 style={{marginBlock: "0"}}>{Jobs_L.job_number}</h6>
                                                                         <small className="text-muted">Order Ref: {Jobs_L.ord_ID}</small>
                                                                        <i className={`ri ${Jobs_L.isMould ? 'ri-coin-line' : ' bx bx-cube'} d-flex fs-16`}> <p style={{marginBlock: "-3px", marginLeft: "5px"}}>{`${Jobs_L.isMould ? 'mould' : ' job'}`}</p> </i>
                                                                    </Link>
                                                                </td>
                                                                <td><strong>{Jobs_L.user_created}</strong></td>
                                                                <td>
                                                                    <strong>{Jobs_L.fullname}</strong>
                                                                </td>
                                                                <td>
                                                                    {Jobs_L.comment}
                                                                </td>
                                                                <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                                                                    <span
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            gap: "5px",
                                                                            width: "100%"
                                                                        }}
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                flex: "1",
                                                                                minWidth: "100px",
                                                                                maxWidth: "200px",
                                                                                textAlign: "left",
                                                                                overflow: "hidden",
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap"
                                                                            }}
                                                                            title={Jobs_L.est_ID === 18 && Jobs_L.reprint > 1 ? "REPRINT FOLDER" : Jobs_L.status_name}
                                                                        >
                                                                            {Jobs_L.est_ID === 18 && Jobs_L.reprint > 1 ? "REPRINT FOLDER" : Jobs_L.status_name}
                                                                        </span>
                                                                        <StatusChart
                                                                            statusId={Jobs_L.est_ID}
                                                                            reprint={Jobs_L.est_ID === 18 && Jobs_L.reprint > 1}
                                                                        />
                                                                    </span>
                                                                </td>

                                                                <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                                                                    <span
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            gap: "10px",
                                                                            width: "100%",
                                                                            flex: "1",
                                                                        }}
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                minWidth: "10px",
                                                                                textAlign: "left",
                                                                                fontSize: "14px",
                                                                                flex: "1",
                                                                            }}
                                                                        >
                                                                            {Jobs_L.reprint}
                                                                        </span>
                                                                        {Jobs_L.reprint > 1 && (
                                                                            <i
                                                                                className="ri-shopping-bag-3-fill"
                                                                                style={{ fontSize: "25px", color: "rgb(162 0 0)" }}
                                                                            ></i>
                                                                        )}
                                                                    </span>
                                                                </td>

                                                                <td>
                                                                    {/*Circle with color */}
                                                                    <span
                                                                        style={{
                                                                            display: "inline-block",
                                                                            width: "12px",
                                                                            height: "12px",
                                                                            backgroundColor: Jobs_L.materials_color || "rgb(226, 226, 226)",
                                                                            borderRadius: "50%",
                                                                            marginRight: "5px",
                                                                        }}
                                                                    ></span>

                                                                    {/*Material name */}
                                                                    {Jobs_L.materials_name}
                                                                </td>


                                                                <td style={{ textAlign: "center" }}>
                                                                    {Jobs_L.qty}
                                                                </td>

                                                                <td >
                                                                    {Jobs_L?.barcode && (
                                                                        <>
                                                                            <QRCode
                                                                                size={25}
                                                                                style={{ height: "10vh", width: "10vh" }}
                                                                                value={`${server_frontend}/jobs/qr-single-job?qr=${Jobs_L.barcode}`}
                                                                                viewBox="0 0 256 256"
                                                                            />
                                                                        </>
                                                                    )}
                                                                </td>

                                                                <td >
                                                                    {Jobs_L.colle_id > 0 ? (
                                                                        <>
                                                                            <QRCode
                                                                                size={25}
                                                                                style={{ height: "10vh", width: "10vh" }}
                                                                                value={`${server_frontend}/jobs/collective/qr-group?group=${Jobs_L.colle_id}`}
                                                                                viewBox="0 0 256 256"
                                                                            />
                                                                        </>
                                                                    ) : (
                                                                        <div
                                                                            style={{
                                                                                height: "10vh",
                                                                                width: "10vh",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                border: "2px solid #ccc",
                                                                                fontSize: "10px",
                                                                                color: "#666",
                                                                                textAlign: "center",
                                                                                padding: "5px",
                                                                            }}
                                                                        >
                                                                            No assigned <br />group
                                                                        </div>
                                                                    )}

                                                                </td>


                                                                <td style={{ textAlign: "center" }}>
                                                                    {vAdminformat.FormatDateSmall(Jobs_L.date_estimated)}
                                                                </td>

                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                        )}

                                        <div className="row justify-content-between align-items-center">
                                            <div className="col-auto me-3">
                                                <p className="text-muted mb-sm-0">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, JobList.length)} of {JobList.length} entries</p>
                                            </div>
                                            <div className="col-auto">
                                                <ul className="pagination pagination-separated pagination-sm justify-content-end mb-sm-0">
                                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                        <a href="#" onClick={() => handlePageChange(currentPage - 1)} className="page-link">←</a>
                                                    </li>
                                                    {Array.from({ length: totalPages }, (_, index) => (
                                                        <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                            <a href="#" onClick={() => handlePageChange(index + 1)} className="page-link">{index + 1}</a>
                                                        </li>
                                                    ))}
                                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                        <a href="#" onClick={() => handlePageChange(currentPage + 1)} className="page-link">→</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="row g-0 text-center text-sm-start">
                                            <div className="col-sm-6">
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            )}
        </div>
    );
};

export default LiveFeed;
